/*
 * (c) Meta Platforms, Inc. and its affiliates.
 */

import { TbZoomPan } from "react-icons/tb";
import ScrollHand from "../../assets/images/hand.png";

const InfoEventsActionsCard = () => {
	return (
		<div className="hidden md:block absolute top-[160px] left-5 z-[10]">
			<div tabIndex={0} className="collapse border bg-black rounded-box">
				<div className="collapse-title text-white">
					<TbZoomPan />
				</div>
				<div className="collapse-content flex">
					<div className="flex w-30 content-center">
						<div>
							<p className="text-[10px] text-white">
								Scroll to zoom in/out <br /> Click to pan
							</p>
						</div>
						<span>
							<img className="w-5 ml-2" src={ScrollHand} alt=""></img>
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InfoEventsActionsCard;
